import axios from 'axios';

const apiClient = axios.create({
    baseURL: process.env.REACT_APP_APPAPI_BASEURL,
});

apiClient.interceptors.request.use(function (config) {
    const value = window.sessionStorage.getItem("user");

    if (value != "null") {
        var user = JSON.parse(value);
        if (user) {
            config.headers.Authorization = user.tokenData.accessToken ? `Bearer ${user.tokenData.accessToken}` : '';
        }
    }
    return config;
});
/**
 * Catch the AunAuthorized Request
 */
apiClient.interceptors.response.use((response) => { return response }, (error) => {

    if (error.response.status === 401 && error.request.responseURL.indexOf("login") <= 0) {
        let params = "";
        const value = window.sessionStorage.getItem("currentApp");

        if (value != "null" && value !== undefined && value !== null) {
            var currentApp = JSON.parse(value);

            if (!isEmpty(currentApp)) {

                if (!isEmpty(currentApp.tenantId)) {
                    params = `/${currentApp.tenantId}`
                }

                if (!isEmpty(currentApp.appId)) {
                    params += `/${currentApp.appId}`
                }
            }
        }

        window.sessionStorage.setItem("user", null);

        window.location = `/authentication/sign-in${params}`;
    }

    function isEmpty(val) {
        return (val === undefined || val == null || val.length <= 0) ? true : false;
    }

    return Promise.reject(error);
});

export default apiClient;